import { PiSignOutDuotone } from "react-icons/pi";
import { ROLE_LABEL } from "../../lib/perms";

export default function MerchantUserMenu({ user, onLogout }) {
  const role = user?.role;
  return (
    <div className="border-t border-border p-3 lg:px-5 lg:py-4 shrink-0">
      <div className="hidden lg:block mb-3">
        <div className="text-sm font-semibold truncate">{user?.name}</div>
        <div className="font-mono text-[10px] tracking-widest uppercase text-primary">
          {ROLE_LABEL[role] || role}
        </div>
      </div>
      <button
        onClick={onLogout}
        data-testid="logout-btn"
        className="flex items-center gap-2 text-xs text-muted-foreground hover:text-destructive transition-colors"
      >
        <PiSignOutDuotone className="text-base" />
        <span className="hidden lg:inline">Sign out</span>
      </button>
    </div>
  );
}
